
<div class="card card-statistics mb-30" >
  <div class="card-body">
    <h5 class="card-title">Instrument Exit Request</h5>
    <form>


      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Customer Name </label>
          <input disabled type="text" value="{{customerName}}" class="form-control" >
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Letter Number </label>
          <input disabled type="text" value="{{code}}" class="form-control" >
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Calibration Technician Name </label>
          <input disabled type="text" value="{{expert}}" class="form-control">
        </div>

      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Instrument Name </label>
          <input disabled type="text" value="{{deviceName}}" class="form-control">
        </div>

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Instrument Code </label>
          <input disabled type="text" value="{{deviceCode}}" class="form-control">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1"> Instrument Serial Number </label>
          <input disabled type="text" value="{{deviceSerial}}" class="form-control">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <label for="exampleInputEmail1"> Description </label>
          <input disabled type="text" value="{{dsc}}" class="form-control">
        </div>
      </div>
    </form>
  </div>
</div>